import * as React from 'react';
import {InclinationChart, PronouncedLabels} from '../../components';

interface CharacteristicBreakdownProps {
    name?: string;
    description: string;
    value?: number;
    content: string;
    preventInteraction?: boolean;
}

export class CharacteristicBreakdown extends React.Component<CharacteristicBreakdownProps> {
    render() {
        const { name, description, value, content } = this.props;
        return (
            <>
                <div className="characteristic-title-modal">{name}</div>
                <div dangerouslySetInnerHTML={{ __html: description }} />

                {!!value && 
                    <div className="chart-container single-area">
                        <PronouncedLabels />
                        <InclinationChart value={Math.round(value)} allowToggle={false} skipAnimation={this.props.preventInteraction} />
                    </div>
                }

                <div dangerouslySetInnerHTML={{ __html: content }} />
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/inclinationmodals/CharacteristicBreakdown.tsx